import { z } from "zod";

export const PatientExternalIdSchema = z.object({
    type: z.enum([
        "NhsNumber",
        "Emis",
        "SystmOne",
        "Vision",
        "ChiNumber",
        "Hospital",
        "UnmatchedNhsNumber",
        "Dummy",
    ]),
    value: z.string(),
});

export type PatientExternalId = z.infer<typeof PatientExternalIdSchema>;
